import { useEffect, useState } from "react";
// import Map from "../components/GoogleMapPage/Map";
import Map from "../GooleMapPage/Map";

const NearYou = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;

      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
    },
    false
  );

  const [city, setCity] = useState(null);

  const handleCity = (name) => {
    setCity(name);
  };

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">
          TCS Location Map
        </h1>
        <p className="text-[1.05rem] mt-[-5px]">
          Locate your nearest Express Centre
        </p>
      </div>
      <Map city={city} />
      <div className="lg:container lg:mx-auto flex flex-col justify-center items-center py-[5rem] mx-[2rem]">
        <h1 className="font-bold text-3xl text-[#373737]">
          Find us in these cities
        </h1>
        <hr className="hr" />

        <div className="mt-4 flex flex-wrap justify-center items-center gap-4 max-w-[70rem] ">
          <div
            className="relative flex justify-center items-center max-w-[20rem]"
            onClick={() => handleCity("Karachi")}
          >
            <img className="cursor-pointer" src="/cities/Karachi.jpg" alt="" />
            <p className="absolute bottom-4 text-white font-semibold text-xl ">
              Karachi
            </p>
          </div>
          <div
            className="relative flex justify-center items-center max-w-[20rem]"
            onClick={() => handleCity("Lahore")}
          >
            <img src="/cities/Lahore.jpg" alt="" className="cursor-pointer" />
            <p className="absolute bottom-4 text-white font-semibold text-xl">
              Lahore
            </p>
          </div>
          <div
            className="relative flex justify-center items-center max-w-[20rem]"
            onClick={() => handleCity("Islamabad")}
          >
            <img
              src="/cities/Islamabad.jpg"
              alt=""
              className="cursor-pointer"
            />
            <p className="absolute bottom-4 text-white font-semibold text-xl">
              Islamabad
            </p>
          </div>
          <div
            className="relative flex justify-center items-center max-w-[20rem]"
            onClick={() => handleCity("Faisalabad")}
          >
            <img
              src="/cities/Faisalabad.png"
              alt=""
              className="cursor-pointer"
            />
            <p className="absolute bottom-4 text-white font-semibold text-xl">
              Faisalabad
            </p>
          </div>
          <div
            className="relative flex justify-center items-center max-w-[20rem]"
            onClick={() => handleCity("Rawalpindi")}
          >
            <img
              src="/cities/Rawalpindi.jpg"
              alt=""
              className="cursor-pointer"
            />
            <p className="absolute bottom-4 text-white font-semibold text-xl">
              Rawalpindi
            </p>
          </div>
          <div
            className="relative flex justify-center items-center max-w-[20rem]"
            onClick={() => handleCity("Multan")}
          >
            <img src="/cities/Multan.png" alt="" className="cursor-pointer" />
            <p className="absolute bottom-4 text-white font-semibold text-xl">
              Multan
            </p>
          </div>
          <div
            className="relative flex justify-center items-center max-w-[20rem]"
            onClick={() => handleCity("Peshawar")}
          >
            <img src="/cities/Peshawar.png" alt="" className="cursor-pointer" />
            <p className="absolute bottom-4 text-white font-semibold text-xl">
              Peshawar
            </p>
          </div>
          <div
            className="relative flex justify-center items-center max-w-[20rem]"
            onClick={() => handleCity("Quetta")}
          >
            <img src="/cities/Quetta.png" alt="" className="cursor-pointer" />
            <p className="absolute bottom-4 text-white font-semibold text-xl">
              Quetta
            </p>
          </div>
          <div
            className="relative flex justify-center items-center max-w-[20rem]"
            onClick={() => handleCity("Gujranwala")}
          >
            <img
              src="/cities/Gujranwala.png"
              alt=""
              className="cursor-pointer"
            />
            <p className="absolute bottom-4 text-white font-semibold text-xl">
              Gujranwala
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NearYou;
